import tempMeeApi from '../../../apis/tempMee';

/**
 * The read model calls it `phoneNumber`; auth-service's admin PATCH reads
 * `phone`. Every other editable key is spelled the same both ways.
 *
 * @param {import('../types/User').ILocationUserChanges} changes
 * @returns {import('../types/User.api').IAdminUpdateUserApiBody}
 */
const toAdminUpdateUserBody = ({ phoneNumber, ...rest }) =>
  (phoneNumber === undefined ? rest : { ...rest, phone: phoneNumber });

/**
 * Updates an auth-service user's own fields as an admin. auth-service answers
 * 204 and tells the monolith (`AUTH_USER_UPDATED`), so the office profile picks
 * the change up too. HTTP only: failures reject with the service's `{ error }`.
 *
 * @param {string} userId - The auth-service user id
 * @param {import('../types/User').ILocationUserChanges} changes - Only the fields to change
 * @returns {Promise<void>}
 */
export const updateUser = async (userId, changes) => {
  await tempMeeApi.patch(`/auth-service/admin/users/${userId}`, toAdminUpdateUserBody(changes));
};
